<template>
    <div class="form-section col-6">
        <h2 class="heading-spacing--medium pb-2">Inloggegevens</h2>
        <div class="row">
            <text-input
                v-model="profile.Email"
                class="col-12"
                name="E-mailadres (gebruikersnaam)"
                :value="profile.Email"
                rules="required"
                :readonly="true"
            />
        </div>
        <div class="row mb-4">
            <text-input
                v-model="profile.Password"
                class="col-12"
                name="Nieuw wachtwoord"
                :value="profile.Password"
                type="password"
            />
            <text-input
                v-model="profile.PasswordRepeat"
                class="col-12"
                name="Herhaal nieuw wachtwoord"
                :value="profile.PasswordRepeat"
                type="password"
            />
        </div>
        <div class="row d-flex flex-row-reverse mt-2">
            <button
                class="btn pl-4 btn--green-1 ml-2"
                @click.prevent="inputPasswordChanged"
            >
                <span>
                    Sla nieuw wachtwoord op
                </span>
            </button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import textInput from '@/components/form/text-input';
import { VueReCaptcha } from 'vue-recaptcha-v3';

Vue.use(VueReCaptcha, { siteKey: '6Le0nPkbAAAAAObFIEw575-1G4shRCyKg3zhUdjM' });

export default {
    components: {
        textInput
    },
    props: {
        profile: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            responseMessage: '',
            updated: false
        };
    },
    methods: {
        inputPasswordChanged() {
            this.$emit('input', this.profile.PasswordRepeat);
        }
    }
};
</script>
